import { BroadcastApiStatus, } from "@dreamcam/web-sdk";
import { Env } from "../settings/Env";
import { DefinitionType, Image3D, ImgButton, ImgToggleButton, LayoutUtils, MeshUtils, ObjectBuilder, Rectangle3D, TabControl, } from "@dreamcam/babylon-tools";
import { createVector3 } from "./ButtonAnimation";
import { text } from "../TextResources";
import { AppView } from "./AppView";
import { LiveGallery, PurchaseGallery, ThumbnailAnimationDuration, VideoGallery } from "./components/Gallery";
import { DcRenderingGroup } from "./DcRenderingGroup";
import { Settings } from "../settings/Settings";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
//import {Image} from "@babylonjs/gui/2D/controls/image.js";
import { Vector3 } from "@babylonjs/core/Maths/math.vector.js";
import { VideosTab } from "../interfaces/LobbyInterfaces";
import { MeshName } from "./MeshName";
import { LoginDialog } from "./components/LoginDialog";
import { NewFeatureBlinkHelper } from "./utils/NewFeatureBlinkHelper";
import { EnvironmentDialog } from "./components/EnvironmentDialog";
import { XRInputHelper } from "./XRInputHelper";
import { LobbyModelsPanelContainer } from "./components/LobbyModelsPanelContainer";
import { LobbySelectedModelPanelContainer } from "./components/LobbySelectedModelPanelContainer";
import { Animation } from "@babylonjs/core/Animations/animation.js";
import { LobbyTagsPanel } from "./components/LobbyTagsPanel";
import { UserPanel } from "./components/UserPanel";
import { MessengerPanel } from "./components/MessengerPanel";
import { MessengerChatListPanel } from "./components/MessengerChatListPanel";
import { Keyboard3D } from "./components/keyboard/Keyboard3D";
import { HideKeyboardComponent } from "./components/HideKeyboardComponent";
import { waitFor } from "../utils/AsyncUtils";
var LiveTab;
(function (LiveTab) {
    LiveTab[LiveTab["allModels"] = 0] = "allModels";
    LiveTab[LiveTab["favorites"] = 1] = "favorites";
})(LiveTab || (LiveTab = {}));
export class LobbyView {
    get _lobbyMode() { return this._callbacks.getLobbyMode(); }
    get _lobbyVideosMode() { return this._callbacks.getLobbyVideosMode(); }
    constructor() {
        this._upcomingEventBlinkInterval = null;
        this._pagination = {};
        this._isVisible = false;
        this._environmentData = null;
        this._newFeatureBlinkHelper = new NewFeatureBlinkHelper();
        this._allLobbyMeshes = [];
        this._appView = AppView.getInstance();
    }
    updateLiveTagGroups(groups) {
        this._lobbyTagsPanel.updateLiveTagGroups(groups);
    }
    updateVideosTags(tags) {
        this._lobbyTagsPanel.updateVideosTags(tags);
    }
    async loadEnvironmentDataAsync() {
        this._environmentData = await this._callbacks?.loadEnvironmentDataAsync() ?? null;
    }
    setLobbyActivity(isActive, excludedMeshNames) {
        // console.log(this._allLobbyMeshes.map(m => `${m.mesh.name}: isVisible: ${m.mesh.isVisible}`));
        this._allLobbyMeshes
            .filter(m => excludedMeshNames.find(x => m.mesh.name === x) === undefined)
            .forEach(m => {
            if (m.mesh.isVisible) {
                // console.log(`${m.mesh.name}: isActive: ${isActive}`);
                m.mesh.isPickable = isActive;
                m.colorMultiplier = isActive ? 1.0 : 0.4;
            }
        });
        this._liveGallery?.setActivity(isActive);
        this._videoGallery?.setActivity(isActive);
        this._purchaseGallery?.setActivity(isActive);
    }
    async hideAsync() {
        this._stopBlinking();
        this.setLobbyActivity(true, []);
        this._isVisible = false;
        this._newFeatureBlinkHelper.stop();
        MeshUtils.hide(this._headerMesh);
        MeshUtils.hide(this._liveTabsMesh);
        MeshUtils.hide(this._videoTabsMesh);
        MeshUtils.hide(this._pagination.mesh);
        MeshUtils.hide(this._upcomingEvent.panel);
        // MeshUtils.hide(this._upcomingEvent!.header);
        this._lobbyTagsPanel.hide();
        MeshUtils.hide(this._modelsMesh);
        MeshUtils.hide(this._selectedModelMesh);
        this._userPanel.hide();
        this._liveGallery.setVisibility(false);
        this._videoGallery.setVisibility(false);
        this._purchaseGallery.setVisibility(false);
        this._loginDialog?.hide();
        this._messengerPanel?.hide();
        this._messengerChatListPanel?.hide();
        this._environmentDialog?.hide();
        this._appView.infoDialog.hide();
        this._appView.onboardingPanel.hide();
        // this._appView.announcementVodPanel.hide();
        // this._appView.announcementMessengerPanel.hide();
        this._appView.announcementPtPanel.hide();
    }
    async showAsync() {
        this._isVisible = true;
        MeshUtils.show(this._headerMesh, { isPickable: false });
        // MeshUtils.setVisibility(this._liveTabsMesh, this._lobbyMode === "Live");
        // MeshUtils.setVisibility(this._videoTabsMesh, this._lobbyMode === "Videos");
        this._lobbyTagsPanel.show();
        MeshUtils.show(this._pagination.mesh);
        // try {
        //     await Promise.all([
        //         this.loadEnvironmentDataAsync(),
        //         this._callbacks?.updateCurrentPostersAsync()
        //     ]);
        // } catch (e) {
        //     console.error(e);
        // }
        const results = await Promise.allSettled([
            this.loadEnvironmentDataAsync(),
            this._callbacks?.updateCurrentPostersAsync()
        ]);
        results.forEach((x, i) => {
            let errorSource = "Unknown source:";
            if (i === 0)
                errorSource = "Error in loadEnvironmentDataAsync():";
            else if (i === 1)
                errorSource = "Error in updateCurrentPostersAsync():";
            if (x.status === "rejected")
                console.error(errorSource, x.reason);
        });
        this._updateSomeMeshVisibilityOnTabChanged();
        // MeshUtils.show(this._upcomingEvent!.panel);
        // this._lobbyTagsPanel.setLobbyMode(this._lobbyMode);
        // MeshUtils.setVisibility(this._modelsMesh!, this._lobbyMode === "Videos" && this._callbacks!.getGalleryModel() === null);
        // MeshUtils.setVisibility(this._selectedModelMesh!, this._lobbyMode === "Videos" && this._callbacks!.getGalleryModel() !== null);
        this._newFeatureBlinkHelper.start();
        this._userPanel.show(this._environmentData, "environment");
        this._messengerPanel.setPinnedModelId(null);
        await this._messengerChatListPanel.setPinnedModelIdAsync(null);
        this._messengerChatListPanel.setSelectedModelId(this._messengerCallbacks.getSelectedModelId());
        this._liveGallery.setVisibility(this._lobbyMode === "Live");
        this._videoGallery.setVisibility(this._lobbyMode === "Videos" && this._lobbyVideosMode === "AllVideos");
        this._purchaseGallery.setVisibility(this._lobbyMode === "Videos" && this._lobbyVideosMode === "Purchased");
        this._videosTabControl.currentTab = this._lobbyVideosMode === "Purchased"
            ? VideosTab.purchased
            : VideosTab.allVideos;
        const settings = Settings.getInstance();
        if (!settings.onboarding.wasViewed) {
            this._appView.onboardingPanel.show();
        }
        else {
            if (!settings.ptAnnouncement.wasViewed) {
                this._appView.announcementPtPanel.show();
                // if (!settings.messengerAnnouncement.wasViewed) {
                //     this._appView.announcementMessengerPanel.show();
                // if (!settings.vodAnnouncement.wasViewed) {
                //     this._appView.announcementVodPanel.show();
                // } else if (!settings.favoritesAnnouncement.wasViewed) {
                //     this._appView.announcementFavoritesPanel.show();
            }
        }
    }
    async initAsync(callbacks) {
        this._callbacks = callbacks;
        await this._initSceneAsync();
        this._environmentDialog = new EnvironmentDialog(this._callbacks);
        if (this._appView.loginApiAuthAsync && this._appView.signupApiAuthAsync) {
            this._loginDialog = new LoginDialog(this._appView.guiRootNode, {
                signInCallback: async (username, password) => {
                    return await this._appView.loginApiAuthAsync(username, password);
                },
                signupCallback: async (email, username, password) => {
                    return await this._appView.signupApiAuthAsync(email, username, password);
                },
                onHideCallback: () => {
                    this.setLobbyActivity(true, []);
                },
            });
        }
    }
    async _initSceneAsync() {
        if (this._headerMesh)
            this._headerMesh.dispose();
        if (this._liveTabsMesh)
            this._liveTabsMesh.dispose();
        if (this._videoTabsMesh)
            this._videoTabsMesh.dispose();
        if (this._pagination.mesh)
            this._pagination.mesh.dispose();
        if (this._liveGallery)
            this._liveGallery.dispose();
        if (this._videoGallery)
            this._videoGallery.dispose();
        if (this._purchaseGallery)
            this._purchaseGallery.dispose();
        this._liveGallery = new LiveGallery((broadcastId, options) => this._callbacks.openBroadcastAsync({
            broadcastId,
            extraOptions: { openedFromPoster: options?.openedFromPoster === true }
        }), this);
        this._videoGallery = new VideoGallery(this);
        this._purchaseGallery = new PurchaseGallery(this);
        const totalSize = this._liveGallery.totalSize();
        this._headerMesh = MeshUtils.createPlaneMesh("lobbyHeaderPanel", Env.lobby.header.width, Env.lobby.header.height, this._appView.scene, this._appView.guiRootNode, DcRenderingGroup.default);
        this._allLobbyMeshes.push(this._headerMesh);
        const headerY = Env.lobby.panel.center.y + totalSize.height / 2 + Env.lobby.tabs.margin.bottom +
            Env.lobby.header.height / 2 + Env.lobby.tabs.height + Env.lobby.tabs.margin.top;
        this._headerMesh.mesh.position = new Vector3(Env.lobby.panel.center.x, headerY, Env.lobby.panel.center.z);
        this._liveTabsMesh = MeshUtils.createPlaneMesh("lobbyLiveTabsPanel", Env.lobby.tabs.live.width, Env.lobby.tabs.height, this._appView.scene, this._appView.guiRootNode, DcRenderingGroup.default);
        this._allLobbyMeshes.push(this._liveTabsMesh);
        const liveTabsY = Env.lobby.panel.center.y + totalSize.height / 2 + Env.lobby.tabs.margin.bottom + Env.lobby.tabs.height / 2;
        this._liveTabsMesh.mesh.position = new Vector3(Env.lobby.panel.center.x, liveTabsY, Env.lobby.panel.center.z);
        XRInputHelper.addPointerAddon(this._liveTabsMesh.mesh).onPointerOut.add(() => this._liveTabsMesh.notifyChildrenOnPointerOut());
        this._videoTabsMesh = MeshUtils.createPlaneMesh("lobbyVideoTabsPanel", Env.lobby.tabs.videos.width, Env.lobby.tabs.height, this._appView.scene, this._appView.guiRootNode, DcRenderingGroup.default);
        this._allLobbyMeshes.push(this._videoTabsMesh);
        const videoTabsY = Env.lobby.panel.center.y + totalSize.height / 2 + Env.lobby.tabs.margin.bottom + Env.lobby.tabs.height / 2;
        this._videoTabsMesh.mesh.position = new Vector3(Env.lobby.panel.center.x, videoTabsY, Env.lobby.panel.center.z);
        XRInputHelper.addPointerAddon(this._videoTabsMesh.mesh).onPointerOut.add(() => this._videoTabsMesh.notifyChildrenOnPointerOut());
        this._pagination.mesh = MeshUtils.createPlaneMesh("lobbyFooterPanel", Env.lobby.footer.width, Env.lobby.footer.height, this._appView.scene, this._appView.guiRootNode, DcRenderingGroup.default);
        this._allLobbyMeshes.push(this._pagination.mesh);
        this._pagination.mesh.mesh.position = new Vector3(0, Env.lobby.footer.meshY, Env.lobby.footer.meshZ + 0.01);
        const navigation = this._createFooter();
        this._pagination.mesh.texture.addControl(navigation);
        const footerPointerAddon = XRInputHelper.addPointerAddon(this._pagination.mesh.mesh);
        footerPointerAddon.onPointerOut.add(() => this._pagination.mesh?.notifyChildrenOnPointerOut());
        this._createHeaderPanel();
        this._createLiveTabsPanel();
        this._createVideoTabsPanel();
        this.updateLoginSection();
        this._createUpcomingEventsPanel();
        this._createModelsPanel();
        this._createSelectedModelPanel();
        const categories = await this._callbacks.loadCategoriesAsync();
        this._lobbyTagsPanel = new LobbyTagsPanel(MeshName.lobbyTags, this._liveGallery.totalSize(), categories, this._callbacks, {
            onLobbyModeChanged: (lobbyMode) => {
                this._callbacks.setLobbyMode(lobbyMode);
                this._liveGallery?.setVisibility(lobbyMode === "Live");
                this._videoGallery?.setVisibility(lobbyMode === "Videos" && this._lobbyVideosMode === "AllVideos");
                this._purchaseGallery?.setVisibility(lobbyMode === "Videos" && this._lobbyVideosMode === "Purchased");
                if (this._isVisible) {
                    this._updateSomeMeshVisibilityOnTabChanged();
                }
                if (this._callbacks) {
                    const livePaginationInfo = this._callbacks.getLivePaginationInfo();
                    this.drawBroadcastsPageInfo(livePaginationInfo.totalPages, livePaginationInfo.currentPageIndex);
                    const videosPaginationInfo = this._callbacks.getVideosPaginationInfo();
                    this.drawVideoClipsPageInfo(videosPaginationInfo.totalPages, videosPaginationInfo.currentPageIndex);
                }
            }
        });
        this._allLobbyMeshes.push(this._lobbyTagsPanel.mesh2d);
        // this._lobbyTagsMesh = this._createTagsMesh(MeshName.lobbyTags);
        // this._createLobbyModePanel(this._lobbyTagsMesh);
        // await this._createLiveTagsPanelAsync(this._lobbyTagsMesh);
        // this._createVideosTagsPanel(this._lobbyTagsMesh);
        this._createUserPanel();
        this._createLobbyKeyboard();
        this._createMessengerPanel();
        this._createMessengerChatListPanel();
    }
    getSceneCallbacks() {
        return this._callbacks;
    }
    drawBroadcasts(thumbnails) {
        this._liveThumbnails = thumbnails;
        this._liveGallery.drawItems(thumbnails, this._lobbyMode);
        const filter = this._callbacks.getCatalogFilter();
        if (filter.favoritesOnly && thumbnails.itemsOnPage === 0) {
            setTimeout(async () => {
                try {
                    const favoriteModels = await this._callbacks.loadFavoriteModelsAsync();
                    if (favoriteModels.length === 0) {
                        this._appView.infoDialog.show("liveFavoritesNoModelsWarning", {
                            actionCallback: () => {
                                this._appView.infoDialog.hide();
                                filter.favoritesOnly = false;
                                this.updateBroadcastFilterTabs(filter);
                            },
                        });
                    }
                }
                catch (e) {
                    console.error(e);
                    filter.favoritesOnly = false;
                    this.updateBroadcastFilterTabs(filter);
                }
            }, 500);
        }
    }
    drawVideoClips(thumbnails) {
        this._selectedModelPanelContainer?.drawVideoClips(thumbnails);
        this._videoGallery.drawItems(thumbnails, this._lobbyMode, this._lobbyVideosMode);
    }
    drawPurchases(thumbnails) {
        this._purchaseGallery.drawItems(thumbnails, this._lobbyMode, this._lobbyVideosMode);
        if (this._lobbyMode === "Videos" && this._lobbyVideosMode === "Purchased" && thumbnails.totalCount === 0) {
            setTimeout(async () => {
                this._appView.infoDialog.show("noPurchasedVideosWarning", {
                    actionCallback: () => {
                        this._appView.infoDialog.hide();
                        this._setLobbyGalleryTabAsync(VideosTab.allVideos);
                    },
                });
            }, 500);
        }
    }
    drawBroadcastsPageInfo(totalPages, currentPageIndex) {
        if (this._lobbyMode !== "Live")
            return;
        this._updateFooter(totalPages, currentPageIndex, this._callbacks ? {
            openPageAsync: this._callbacks.openLivePageAsync,
            nextPageAsync: this._callbacks.nextLivePageAsync,
            previousPageAsync: this._callbacks.previousLivePageAsync,
        } : undefined);
    }
    drawVideoClipsPageInfo(totalPages, currentPageIndex) {
        if (this._lobbyMode !== "Videos" || this._lobbyVideosMode !== "AllVideos")
            return;
        this._updateFooter(totalPages, currentPageIndex, this._callbacks ? {
            openPageAsync: this._callbacks.openVideosPageAsync,
            nextPageAsync: this._callbacks.nextVideosPageAsync,
            previousPageAsync: this._callbacks.previousVideosPageAsync,
        } : undefined);
    }
    drawPurchasesPageInfo(totalPages, currentPageIndex) {
        if (this._lobbyMode !== "Videos" || this._lobbyVideosMode !== "Purchased")
            return;
        this._updateFooter(totalPages, currentPageIndex, this._callbacks ? {
            openPageAsync: this._callbacks.openPurchasesPageAsync,
            nextPageAsync: this._callbacks.nextPurchasesPageAsync,
            previousPageAsync: this._callbacks.previousPurchasesPageAsync,
        } : undefined);
    }
    updateLoginSection(data) {
        if (this._videosTabControl && data?.nickname === undefined) {
            this._videosTabControl.currentTab = VideosTab.allVideos;
        }
        this._userPanel?.outputUserData(data);
    }
    getInfoDialog() {
        return this._appView.infoDialog;
    }
    async startLoginAsync(tab) {
        if (this._appView.isApiAuth)
            this._loginDialog?.show(tab);
        else
            await this._appView.loginAsync();
    }
    outputIsFavorite(modelId, isFavorite) {
        if (modelId !== null) {
            // Change isFavorite marks on the thumbnail page:
            if (this._liveThumbnails && this._isVisible) {
                let hasChanges = false;
                this._liveThumbnails.pageItems.forEach(thumbnail => {
                    const broadcastWrapper = thumbnail.broadcast;
                    if (broadcastWrapper !== null && broadcastWrapper.modelId === modelId && broadcastWrapper.isFavorite !== isFavorite) {
                        const broadcast = broadcastWrapper._broadcast;
                        broadcast.isFavorite = isFavorite;
                        hasChanges = true;
                    }
                });
                if (hasChanges) {
                    this.drawBroadcasts(this._liveThumbnails);
                }
            }
            this._messengerChatListPanel?.outputMessengerIsFavoriteChanged(modelId, isFavorite);
            this._messengerPanel?.outputMessengerIsFavoriteChanged(modelId, isFavorite);
        }
    }
    setMessengerDataCallbacks(callbacks) {
        this._messengerCallbacks = callbacks;
        this._messengerPanel?.setMessengerDataCallbacks(callbacks);
        this._messengerChatListPanel?.setMessengerDataCallbacks(callbacks);
    }
    outputMessengerModelStatuses(modelStatuses) {
        this._messengerPanel?.outputMessengerModelStatuses(modelStatuses);
        this._messengerChatListPanel?.outputMessengerModelStatuses(modelStatuses);
    }
    outputMessengerSelectedModel(modelId, chat) {
        if (modelId !== null) {
            this._messengerPanel?.setPinnedModelId(modelId);
            this._messengerPanel?.outputPinnedProfilePhoto(Env.lobby.gallery.defaultPreview.path);
            this._messengerChatListPanel?.outputPinnedProfilePhoto(Env.lobby.gallery.defaultPreview.path);
        }
        this._messengerChatListPanel?.outputMessengerSelectedModel(modelId);
        this._messengerPanel?.outputMessengerSelectedModel(modelId, chat);
        if (modelId !== null) {
            const resolveAvatar = async () => {
                try {
                    const appCtrl = AppView.getInstance().appController;
                    const sdk = appCtrl.sdk;
                    const bm = sdk.broadcastManager;
                    const b = bm.broadcast;
                    const fromBroadcast = b?.modelProfilePhotoUrl;
                    let url = fromBroadcast;
                    if ((url === undefined || url === "") && this._liveThumbnails && this._liveThumbnails.pageItems?.length > 0) {
                        const item = this._liveThumbnails.pageItems.find((x) => x.broadcast?.modelId === modelId);
                        const liveUrl = item?.broadcast?.modelProfilePhotoUrl;
                        if (liveUrl)
                            url = liveUrl;
                    }
                    const messengerAuthorized = appCtrl?.messengerSdk?.authManager?.isAuthorized === true;
                    if ((url === undefined || url === "") && messengerAuthorized) {
                        await appCtrl.messengerSdk.chatManager.getChatsAsync(Env.common.messengerConfig.paramLimitChats);
                        const chats = appCtrl.messengerSdk.chatManager.chats;
                        const updated = chats.find(c => c.participant.user_id === modelId);
                        const maybe = updated?.participant.avatar;
                        if (maybe)
                            url = maybe;
                    }
                    if ((url === undefined || url === "") && !messengerAuthorized) {
                        return;
                    }
                    if (url !== undefined && url !== "" && await this._validateImageUrl(url)) {
                        this._messengerPanel?.setPinnedModelId(modelId);
                        this._messengerPanel?.outputPinnedProfilePhoto(url);
                        this._messengerChatListPanel?.outputPinnedProfilePhoto(url);
                        this._messengerChatListPanel?.overrideChatAvatar(modelId, url);
                    }
                }
                catch {
                }
            };
            resolveAvatar();
        }
    }
    async _validateImageUrl(url) {
        try {
            const img = new Image();
            let done = false;
            let result = false;
            const finish = (ok) => { if (!done) {
                done = true;
                result = ok;
            } };
            img.onload = () => finish(true);
            img.onerror = () => finish(false);
            img.src = url;
            await waitFor(() => done === true, 3000, { logErrorOnTimeout: false, rejectOnTimeout: false });
            return result;
        }
        catch {
            return false;
        }
    }
    outputMessengerLoggedState(isAuthorized) {
        this._userPanel?.outputMessengerLoggedState(isAuthorized);
    }
    outputMessengerUnreadMessagesCount(unreadChats) {
        this._userPanel?.outputUnreadMessagesCount(unreadChats);
        this._messengerPanel?.outputUnreadMessagesCount(unreadChats);
    }
    outputMessengerChats(chatList) {
        // this._messengerPanel?.outputMessengerChats(chatList);
        this._messengerChatListPanel?.outputMessengerChats(chatList);
    }
    outputMessengerChatChangedForChatList(args) {
        this._messengerChatListPanel?.outputMessengerChatChanged(args);
    }
    outputMessengerChatChangedForMessages(args) {
        this._messengerPanel?.outputMessengerChatChanged(args);
    }
    outputMessengerModelTypingChanged(chatId, isTyping) {
        this._messengerPanel?.outputMessengerModelTypingChanged(chatId, isTyping);
        this._messengerChatListPanel?.outputMessengerModelTypingChanged(chatId, isTyping);
    }
    outputMessengerMessages(chatId, messageListByDate) {
        this._messengerPanel?.outputMessengerMessages(chatId, messageListByDate);
    }
    // outputMessengerIsFavoriteChanged(modelId: string, isFavorite: boolean): void {
    //     this._messengerChatListPanel?.outputMessengerIsFavoriteChanged(modelId, isFavorite);
    //     this._messengerPanel?.outputMessengerIsFavoriteChanged(modelId, isFavorite);
    // }
    // outputMessengerPinnedChat(chat: Nullable<IChat>): void {
    //     this._messengerChatListPanel?.outputMessengerPinnedChat(false, chat);
    //     this._messengerPanel?.outputMessengerPinnedChat(chat);
    // }
    //
    // outputMessengerSelectedChat(chat: Nullable<IChat>): void {
    //     this._messengerChatListPanel?.outputMessengerSelectedChat(chat);
    //     this._messengerPanel?.outputMessengerSelectedChat(chat);
    // }
    _updateFooter(totalPages, currentPageIndex, callbacks) {
        this._pagination.panelContainer?.clearControls();
        if (totalPages <= 1) {
            return;
        }
        const footerHeightPx = this._pagination.mesh.m2px(Env.lobby.footer.height);
        const neighbourButtonWidthPx = this._pagination.mesh.m2px(Env.lobby.footer.buttonWidth);
        const addPaginationButton = (name, btn, page = 1) => {
            const button = btn.img === undefined ? new ImgToggleButton(name, LayoutUtils.GetButtonLayout(btn.layout, this._pagination.mesh)) : new ImgButton(name, LayoutUtils.GetButtonLayout(btn.layout, this._pagination.mesh));
            button.widthInPixels = neighbourButtonWidthPx;
            button.heightInPixels = footerHeightPx;
            if (btn.img !== undefined) {
                const image = new Image3D("neighborButtonImage", btn.img);
                image.widthInPixels = this._pagination.mesh.m2px(Env.lobby.footer.buttonWidth);
                image.heightInPixels = this._pagination.mesh.m2px(Env.lobby.footer.height);
                button.addControl(image);
            }
            else {
                button.addControl(ObjectBuilder.createTextBlock3D(this._pagination.mesh, "", `${page}`, Env.lobby.footer.pageButton.text));
            }
            this._pagination.panelContainer?.addControl(button);
            return button;
        };
        const addNeighbourButtonGap = () => {
            const gap = new Control();
            gap.widthInPixels = this._pagination.mesh.m2px(Env.lobby.footer.arrowButtonGap);
            gap.heightInPixels = 1;
            this._pagination.panelContainer?.addControl(gap);
        };
        let isSwitchingPage = false;
        const previousButton = addPaginationButton("previous", Env.lobby.footer.arrowBack);
        previousButton.onClickObserver.add(async () => {
            if (isSwitchingPage)
                return;
            isSwitchingPage = true;
            await callbacks?.previousPageAsync();
            isSwitchingPage = false;
        });
        addNeighbourButtonGap();
        const pageRange = Env.lobby.footer.pageButtonRange;
        const maxPages = (pageRange * 2) + 1;
        const firstButton = addPaginationButton(`page0`, Env.lobby.footer.pageButton, 1);
        firstButton.group = "pageButtons";
        if (currentPageIndex === 0)
            firstButton.isToggled = true;
        firstButton.onIsToggledChangedObservable.add(async (v) => {
            if (!v || isSwitchingPage)
                return;
            isSwitchingPage = true;
            await callbacks?.openPageAsync(0);
            isSwitchingPage = false;
        });
        for (let i = 1, j = Math.max(1, Math.min(currentPageIndex - pageRange + 1, totalPages - maxPages + 1)); j < totalPages && i < maxPages; i++, j++) {
            const button = addPaginationButton(`page${j}`, Env.lobby.footer.pageButton, j + 1);
            button.group = "pageButtons";
            if (j === currentPageIndex)
                button.isToggled = true;
            button.onIsToggledChangedObservable.add(async (v) => {
                if (!v || isSwitchingPage)
                    return;
                isSwitchingPage = true;
                await callbacks?.openPageAsync(j);
                isSwitchingPage = false;
            });
        }
        addNeighbourButtonGap();
        const nextButton = addPaginationButton("forward", Env.lobby.footer.arrowForward);
        nextButton.onClickObserver.add(async () => {
            if (isSwitchingPage)
                return;
            isSwitchingPage = true;
            await callbacks?.nextPageAsync();
            isSwitchingPage = false;
        });
    }
    _createFooter() {
        this._pagination.panelContainer = new StackPanel("paginationContainer");
        this._pagination.panelContainer.isVertical = false;
        this._pagination.panelContainer.heightInPixels = this._pagination.mesh.m2px(Env.lobby.footer.height);
        this._pagination.panelContainer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        this._pagination.panelContainer.spacing = this._pagination.mesh.m2px(Env.lobby.footer.spacing);
        return this._pagination.panelContainer;
    }
    _createHeaderPanel() {
        const heightPx = this._headerMesh.m2px(Env.lobby.header.height);
        const logo = new Image3D("logo", Env.lobby.header.logo.path);
        logo.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        logo.onImageLoadedObservable.addOnce((image) => {
            logo.heightInPixels = heightPx;
            logo.widthInPixels = image.domImage.width * heightPx / image.domImage.height;
        });
        this._headerMesh.texture.addControl(logo);
    }
    _createFilterTab(name, mesh2d, tabControl, width, imageLayout, imageSrc, caption, isToggled) {
        const t = Env.lobby.tabs;
        const tabRectangle = new Rectangle3D(`tabsPanel${name}TabRectangle`);
        tabRectangle.widthInPixels = mesh2d.m2px(width);
        tabRectangle.heightInPixels = mesh2d.m2px(t.height);
        tabRectangle.thickness = 0;
        tabControl.addControl(null, tabRectangle, LayoutUtils.GetButtonLayout(t.tab.buttonLayout, mesh2d), { value: tabRectangle.widthInPixels, type: DefinitionType.Pixel });
        const tabImage = new Image3D(`tabsPanel${name}TabImage`, imageSrc);
        tabImage.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        tabImage.verticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        tabImage.widthInPixels = mesh2d.m2px(imageLayout.width);
        tabImage.heightInPixels = mesh2d.m2px(imageLayout.height);
        tabImage.paddingLeftInPixels = mesh2d.m2px(imageLayout.padding.left);
        tabImage.paddingRightInPixels = mesh2d.m2px(imageLayout.padding.right);
        tabImage.paddingTopInPixels = mesh2d.m2px(imageLayout.padding.top);
        tabImage.paddingBottomInPixels = mesh2d.m2px(imageLayout.padding.bottom);
        tabRectangle.addControl(tabImage);
        const tabCaption = ObjectBuilder.createTextBlock3D(mesh2d, `tabsPanel${name}TabText`, caption, t.tab.fontStyle);
        tabCaption.heightInPixels = mesh2d.m2px(t.height);
        if (isToggled) {
            setTimeout(() => tabRectangle.stateController.changeState("toggled", true), 0);
        }
        tabRectangle.addControl(tabCaption);
        return tabRectangle;
    }
    ;
    _createLiveTabsPanel() {
        const t = Env.lobby.tabs;
        this._liveTabControl = new TabControl("liveTabControl");
        this._liveTabControl.background = "transparent";
        this._liveTabControl.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this._liveTabControl.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._liveTabControl.widthInPixels = this._liveTabsMesh.m2px(t.live.width);
        this._liveTabControl.heightInPixels = this._liveTabsMesh.m2px(t.height);
        this._liveTabsMesh.texture.addControl(this._liveTabControl);
        this._createFilterTab("AllModels", this._liveTabsMesh, this._liveTabControl, t.live.allModels.width, t.tab.imageLayout, t.live.allModels.image, text.lobby_tabs_live_all_models, false);
        this._createFilterTab("Favorites", this._liveTabsMesh, this._liveTabControl, t.live.favorites.width, t.tab.imageLayout, t.live.favorites.image, text.lobby_tabs_live_favorites, false);
        this._liveTabControl.currentTab = LiveTab.allModels;
        this._liveTabControl.onTabChangedObservable.add((index) => {
            if (this._callbacks === undefined)
                return;
            switch (index) {
                case LiveTab.allModels:
                    if (this._callbacks.getCatalogFilter().favoritesOnly) {
                        this._lobbyTagsPanel?.disableTabControl();
                        this._callbacks.getCatalogFilter().favoritesOnly = false;
                    }
                    break;
                case LiveTab.favorites:
                    if (this._callbacks.isAuthorized()) {
                        if (!this._callbacks.getCatalogFilter().favoritesOnly) {
                            this._lobbyTagsPanel?.disableTabControl();
                            this._callbacks.getCatalogFilter().favoritesOnly = true;
                        }
                    }
                    else { // not authorized:
                        this._appView.infoDialog.show("liveFavoritesLoginWarning", {
                            actionCallback: async () => {
                                this._appView.infoDialog.hide();
                                await this.startLoginAsync("signIn");
                            },
                            // onHideOnceCallback: () => console.log("+++++++++++++++"),
                        });
                        this.updateBroadcastFilterTabs(this._callbacks.getCatalogFilter());
                    }
                    break;
            }
            this._updateSomeMeshVisibilityOnTabChanged();
        });
    }
    async _setLobbyGalleryTabAsync(index) {
        if (this._callbacks === undefined)
            return;
        this._lobbyTagsPanel?.disableTabControl();
        try {
            switch (index) {
                case VideosTab.allVideos:
                    this._callbacks.setLobbyVideosMode("AllVideos");
                    const paginationInfo = this._callbacks.getVideosPaginationInfo();
                    this._lobbyTagsPanel?.disableTabControl();
                    await this._callbacks.openVideosPageAsync(paginationInfo.currentPageIndex);
                    // this._callbacks.setLobbyVideosMode("AllVideos");
                    this._videoGallery?.setVisibility(true);
                    this._purchaseGallery?.setVisibility(false);
                    if (this._videosTabControl && this._videosTabControl.currentTab !== index) {
                        setTimeout(() => this._videosTabControl.currentTab = index);
                    }
                    break;
                case VideosTab.purchased:
                    if (this._callbacks.isAuthorized()) {
                        this._callbacks.setLobbyVideosMode("Purchased");
                        const paginationInfo = this._callbacks.getPurchasesPaginationInfo();
                        await this._callbacks.openPurchasesPageAsync(paginationInfo.currentPageIndex);
                        // this._callbacks.setLobbyVideosMode("Purchased");
                        this._videoGallery?.setVisibility(false);
                        this._purchaseGallery?.setVisibility(true);
                        if (this._videosTabControl && this._videosTabControl.currentTab !== index) {
                            setTimeout(() => this._videosTabControl.currentTab = index);
                        }
                    }
                    else { // not authorized:
                        this._appView.infoDialog.show("purchasedVideosLoginWarning", {
                            actionCallback: async () => {
                                this._appView.infoDialog.hide();
                                await this.startLoginAsync("signIn");
                            },
                        });
                        setTimeout(() => this._videosTabControl.currentTab = VideosTab.allVideos);
                    }
                    break;
            }
            this._updateSomeMeshVisibilityOnTabChanged();
        }
        finally {
            this._lobbyTagsPanel?.enableTabControl();
        }
    }
    _createVideoTabsPanel() {
        const t = Env.lobby.tabs;
        this._videosTabControl = new TabControl("videoTabsPanel");
        this._videosTabControl.background = "transparent";
        this._videosTabControl.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this._videosTabControl.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._videosTabControl.widthInPixels = this._videoTabsMesh.m2px(t.videos.width);
        this._videosTabControl.heightInPixels = this._videoTabsMesh.m2px(t.height);
        this._videoTabsMesh.texture.addControl(this._videosTabControl);
        this._createFilterTab("AllVideos", this._videoTabsMesh, this._videosTabControl, t.videos.allVideos.width, t.tab.imageLayout, t.videos.allVideos.image, text.lobby_tabs_videos_all_videos, false);
        this._createFilterTab("Purchased", this._videoTabsMesh, this._videosTabControl, t.videos.purchased.width, t.tab.imageLayout, t.videos.purchased.image, text.lobby_tabs_videos_purchased, false);
        this._videosTabControl.currentTab = VideosTab.allVideos;
        // this._videosTabControl.currentTab =
        //     this._appView.appController.scenesSwitcher.getSitePageParams().lobbyPageParams?.lobbyVideosMode === "Purchased"
        //     ? VideosTab.purchased
        //     : VideosTab.allVideos;
        // console.log(`%c+++++++++ _videosTabControl.currentTab: ${this._videosTabControl.currentTab}`, "background-color: gold");
        this._videosTabControl.onTabChangedObservable.add(async (index) => {
            await this._setLobbyGalleryTabAsync(index);
        });
    }
    updateBroadcastFilterTabs(filter) {
        if (this._liveTabControl) {
            this._liveTabControl.currentTab = filter.favoritesOnly ? LiveTab.favorites : LiveTab.allModels;
        }
    }
    // updateVideosFilterTabs(videosTab: VideosTab): void {
    //     if (this._videosTabControl) {
    //         this._videosTabControl.currentTab = videosTab;
    //     }
    // }
    _createUpcomingEventsPanel() {
        const ue = Env.lobby.upcomingEvents;
        const panelMesh = MeshUtils.createPlaneMesh(MeshName.upcomingEventsPanel, 0.001, 0.001, this._appView.scene, this._appView.guiRootNode, DcRenderingGroup.default);
        this._allLobbyMeshes.push(panelMesh);
        panelMesh.mesh.position = createVector3(ue.mesh.panelPosition);
        // const headerMesh = MeshUtils.createPlaneMesh(MeshName.upcomingEventsHeader,0.001,0.001, this._appView.scene,
        //                                        this._appView.guiRootNode, DcRenderingGroup.default);
        // const deltaY = this._liveGallery!.totalSize().height / 2 + ue.headerMesh.height / 2 + ue.headerMesh.yOffset;
        // headerMesh.mesh.position = createVector3(ue.mesh.headerPosition)
        //     .add(new Vector3(0, deltaY, 0));
        this._upcomingEvent = {
            panel: panelMesh,
            // header: headerMesh,
            prevRotation: 0,
            imageContainer: new Rectangle3D("upcomingEventImageContainer"),
            image: new Image3D("upcomingEventImage"),
            labelLive: {
                background: new Rectangle3D("labelLiveBackground"),
                text: ObjectBuilder.createTextBlock3D(panelMesh, "labelLiveText", text.lobby_upcoming_event_status_live, Env.lobby.upcomingEvents.labelLive.text),
            },
        };
        const labelLive = this._upcomingEvent.labelLive;
        const ll = Env.lobby.upcomingEvents.labelLive;
        labelLive.background.leftInPixels = this._upcomingEvent.panel.m2px(ll.left);
        labelLive.background.topInPixels = this._upcomingEvent.panel.m2px(ll.top);
        labelLive.background.isHitTestVisible = false;
        labelLive.background.adaptWidthToChildren = true;
        labelLive.background.adaptHeightToChildren = true;
        labelLive.background.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        labelLive.background.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        labelLive.background.cornerRadius = this._upcomingEvent.panel.m2px(ll.background.cornerRadius);
        labelLive.background.thickness = 0;
        labelLive.background.background = ll.background.color;
        this._upcomingEvent.imageContainer.addControl(labelLive.background);
        labelLive.text.isHitTestVisible = false;
        labelLive.background.addControl(labelLive.text);
    }
    async updatePostersAsync(currentPosters) {
        let poster = undefined;
        if (currentPosters.highlight.length > 0)
            poster = currentPosters.highlight[0];
        else if (currentPosters.show.length > 0)
            poster = currentPosters.show[0];
        //TODO DZZ Remove mock!
        // poster = {
        //     modelNickname: "Model-775",
        //     broadcastId: "12345",
        //     images: {
        //         desktop: "",
        //         mobile: "",
        //         xr: "https://assets.dreamcam.com/default/xr/2.5.1/lobby/upcomingEvents.jpg",
        //     },
        // };
        const ue = Env.lobby.upcomingEvents;
        const upcomingEvent = this._upcomingEvent;
        upcomingEvent.panel.mesh.isVisible = false;
        // upcomingEvent.header.mesh.isVisible = false;
        upcomingEvent.image.onImageLoadedObservable.add(async (e) => {
            const height = this._liveGallery.totalSize().height;
            const width = e.domImage.width / e.domImage.height * height;
            upcomingEvent.panel.resize(width, height);
            // upcomingEvent.header.resize(width, ue.headerMesh.height);
            // noinspection UnnecessaryLocalVariableJS
            const isUpcomingEventMeshVisible = this._isVisible && this._lobbyMode === "Live";
            upcomingEvent.panel.mesh.isVisible = isUpcomingEventMeshVisible;
            // upcomingEvent.header.mesh.isVisible = isUpcomingEventMeshVisible;
            // upcomingEvent.header.texture.addControl(ObjectBuilder.createTextBlock3D(upcomingEvent.header, "upcomingEventsHeader", text.lobby_upcomingEvents, ue.header));
            const galleryHalfAngle = this._liveGallery.totalSize().angularWidth / 2;
            const imageHalfAngle = Math.atan2(width / 2, ue.mesh.panelPosition.z);
            const rotationAngle = galleryHalfAngle + imageHalfAngle + ue.mesh.rotationAnglePadding * Math.PI / 180;
            upcomingEvent.panel.mesh.rotateAround(Vector3.Zero(), Vector3.Up(), rotationAngle - upcomingEvent.prevRotation);
            // upcomingEvent.header.mesh.rotateAround(Vector3.Zero(), Vector3.Up(), rotationAngle - upcomingEvent.prevRotation);
            upcomingEvent.prevRotation = rotationAngle;
            upcomingEvent.image.widthInPixels = upcomingEvent.panel.m2px(upcomingEvent.panel.width);
            upcomingEvent.image.heightInPixels = upcomingEvent.panel.m2px(upcomingEvent.panel.height);
            upcomingEvent.imageContainer.adaptHeightToChildren = true;
            upcomingEvent.imageContainer.adaptWidthToChildren = true;
            upcomingEvent.imageContainer.thickness = 0;
            upcomingEvent.imageContainer.cornerRadius = upcomingEvent.panel.m2px(ue.cornerRadius);
            upcomingEvent.panel.texture._rootContainer.clearControls();
            upcomingEvent.panel.texture.addControl(upcomingEvent.imageContainer);
            upcomingEvent.imageContainer.clearControls();
            upcomingEvent.imageContainer.addControl(upcomingEvent.image);
            upcomingEvent.imageContainer.addControl(upcomingEvent.labelLive.background);
            upcomingEvent.labelLive.background.addControl(upcomingEvent.labelLive.text);
            upcomingEvent.image.onPointerClickObservable.clear();
            upcomingEvent.image.onPointerClickObservable.add(() => {
                this._appView.appController.scenesSwitcher.openBroadcastAsync({ modelNickname: poster?.modelNickname, extraOptions: { openedFromPoster: true } });
            });
            upcomingEvent.unhoveredPosition = upcomingEvent.panel.mesh.position;
            upcomingEvent.panel.mesh.computeWorldMatrix(true);
            upcomingEvent.hoveredPosition = Vector3.TransformCoordinates(new Vector3(0, 0, Env.lobby.upcomingEvents.mesh.focusedOffset), upcomingEvent.panel.mesh._localMatrix);
            const framesPerSecond = 50;
            const lastFrame = Math.round(framesPerSecond * ThumbnailAnimationDuration);
            upcomingEvent.unhoverAnimation = new Animation("unhoverAnimation", "position", framesPerSecond, Animation.ANIMATIONTYPE_VECTOR3);
            upcomingEvent.unhoverAnimation.setKeys([{ frame: 0, value: upcomingEvent.hoveredPosition }, { frame: lastFrame, value: upcomingEvent.unhoveredPosition }]);
            upcomingEvent.hoverAnimation = new Animation("hoverAnimation", "position", framesPerSecond, Animation.ANIMATIONTYPE_VECTOR3);
            upcomingEvent.hoverAnimation.setKeys([{ frame: 0, value: upcomingEvent.unhoveredPosition }, { frame: lastFrame, value: upcomingEvent.hoveredPosition }]);
            upcomingEvent.image.onPointerEnterObservable.clear();
            upcomingEvent.image.onPointerEnterObservable.add(async () => {
                // upcomingEvent.panel.mesh.position = upcomingEvent.hoveredPosition!;
                upcomingEvent.panel.mesh.animations = [upcomingEvent.hoverAnimation];
                const anim = upcomingEvent.panel.mesh.getScene().beginAnimation(upcomingEvent.panel.mesh, 1, upcomingEvent.hoverAnimation.getHighestFrame());
                await anim.waitAsync();
                upcomingEvent.panel.mesh.animations = [];
            });
            upcomingEvent.image.onPointerOutObservable.clear();
            upcomingEvent.image.onPointerOutObservable.add(async () => {
                // upcomingEvent.panel.mesh.position = upcomingEvent.unhoveredPosition!;
                upcomingEvent.panel.mesh.animations = [upcomingEvent.unhoverAnimation];
                const anim = upcomingEvent.panel.mesh.getScene().beginAnimation(upcomingEvent.panel.mesh, 1, upcomingEvent.unhoverAnimation.getHighestFrame());
                await anim.waitAsync();
                upcomingEvent.panel.mesh.animations = [];
            });
        });
        let showLiveLabel = false;
        if (poster !== undefined) {
            upcomingEvent.image.setSource(undefined);
            upcomingEvent.image.setSource(poster.images.xr);
            showLiveLabel = poster.broadcastStatus === BroadcastApiStatus.PUBLIC;
        }
        upcomingEvent.labelLive.background.isVisible = showLiveLabel;
        this._stopBlinking();
        if (showLiveLabel)
            this._startBlinking();
    }
    _stopBlinking() {
        if (this._upcomingEventBlinkInterval !== null) {
            clearInterval(this._upcomingEventBlinkInterval);
            this._upcomingEventBlinkInterval = null;
            if (this._upcomingEvent) {
                this._upcomingEvent.labelLive.text.isVisible = false;
            }
        }
    }
    _startBlinking() {
        this._stopBlinking();
        this._upcomingEventBlinkInterval = setInterval(() => {
            if (this._upcomingEvent) {
                this._upcomingEvent.labelLive.text.isVisible = !this._upcomingEvent.labelLive.text.isVisible;
            }
        }, 500);
    }
    _createModelsMesh(name) {
        const m = Env.lobby.models;
        const result = MeshUtils.createPlaneMesh(name, m.mesh.width, this._liveGallery.totalSize().height, this._appView.scene, this._appView.guiRootNode, DcRenderingGroup.default);
        result.mesh.position = createVector3(m.mesh.panelPosition);
        const galleryHalfAngle = this._liveGallery.totalSize().angularWidth / 2;
        const panelHalfAngle = Math.atan2(m.mesh.width / 2, m.mesh.panelPosition.z);
        const rotationAngle = galleryHalfAngle + panelHalfAngle + m.mesh.rotationAnglePadding * Math.PI / 180;
        result.mesh.rotateAround(Vector3.Zero(), Vector3.Up(), rotationAngle);
        const pointerAddon = XRInputHelper.addPointerAddon(result.mesh);
        pointerAddon.onPointerOut.add(() => result?.notifyChildrenOnPointerOut());
        // result.texture.background = "#ff000020";
        MeshUtils.setVisibility(result, false);
        return result;
    }
    _createModelsPanel() {
        this._modelsMesh = this._createModelsMesh(MeshName.modelsPanel);
        this._allLobbyMeshes.push(this._modelsMesh);
        this._modelsPanelContainer = new LobbyModelsPanelContainer(this._modelsMesh, this._callbacks);
    }
    _createSelectedModelPanel() {
        this._selectedModelMesh = this._createModelsMesh(MeshName.selectedModelPanel);
        this._allLobbyMeshes.push(this._selectedModelMesh);
        this._selectedModelPanelContainer = new LobbySelectedModelPanelContainer(this._selectedModelMesh, this._callbacks);
    }
    _updateSomeMeshVisibilityOnTabChanged() {
        MeshUtils.setVisibility(this._liveTabsMesh, this._lobbyMode === "Live");
        MeshUtils.setVisibility(this._videoTabsMesh, this._lobbyMode === "Videos");
        if (this._upcomingEvent) {
            MeshUtils.setVisibility(this._upcomingEvent.panel, this._lobbyMode === "Live" || this._lobbyVideosMode === "Purchased");
        }
        this._lobbyTagsPanel?.setPanelsVisibility({
            liveTagsPanelVisible: this._lobbyMode === "Live",
            videoTagsPanelVisible: this._lobbyMode === "Videos" && this._lobbyVideosMode === "AllVideos",
            videoTagsPurchasesPanelVisible: this._lobbyMode === "Videos" && this._lobbyVideosMode === "Purchased",
        });
        this.updateModelMode();
    }
    enableLobbyModeTabControl() {
        this._lobbyTagsPanel?.enableTabControl();
    }
    updateModelMode() {
        if (this._modelsMesh && this._selectedModelMesh) {
            const hasSelectedModel = this._callbacks.getGalleryModel() !== null;
            const inAllVideosMode = this._lobbyMode === "Videos" && this._lobbyVideosMode === "AllVideos";
            MeshUtils.setVisibility(this._modelsMesh, inAllVideosMode && !hasSelectedModel);
            MeshUtils.setVisibility(this._selectedModelMesh, inAllVideosMode && hasSelectedModel);
        }
    }
    getModelsOnPage() {
        const pageMaxHeight = this._liveGallery.totalSize().height -
            Env.lobby.models.header.height -
            Env.lobby.models.pagination.height -
            Env.lobby.models.itemsGroupMargin.top;
        return Math.floor(pageMaxHeight / Env.lobby.models.item.height);
    }
    updateModelsPage(studioModels) {
        this._modelsPanelContainer?.updateModelsPage(studioModels);
    }
    updateModelsPageInfo(pagination) {
        this._modelsPanelContainer?.updateModelsPageInfo(pagination);
    }
    updateSelectedModelInfo(studioModel, broadcast) {
        this._selectedModelPanelContainer?.updateSelectedModelInfo(studioModel, broadcast);
    }
    _createUserPanel() {
        const up = Env.lobby.userPanel2;
        const panelMesh = MeshUtils.createPlaneMesh(MeshName.lobbyUserPanel, up.width, up.height, this._appView.scene, this._appView.guiRootNode, DcRenderingGroup.behindDialogs);
        this._allLobbyMeshes.push(panelMesh);
        panelMesh.mesh.position = createVector3(new Vector3(0, up.meshY, up.meshDistance));
        // panelMesh.mesh.rotateAround(Vector3.Zero(), Vector3.Right(), up.meshRotation * Math.PI / 180);
        const panelMeshPointerAddon = XRInputHelper.addPointerAddon(panelMesh.mesh);
        panelMeshPointerAddon.onPointerOut.add(() => {
            // console.log("%c++++ [1] pointer out", "background-color: orange");
            panelMesh.notifyChildrenOnPointerOut();
        });
        const signoutMesh = MeshUtils.createPlaneMesh(MeshName.lobbyUserSignoutPanel, up.signoutPanel.width, up.signoutPanel.height, this._appView.scene, panelMesh.mesh, DcRenderingGroup.dialogs);
        this._allLobbyMeshes.push(signoutMesh);
        signoutMesh.mesh.position = createVector3(new Vector3(-up.width / 2 + up.signoutPanel.width / 2, -up.height / 2 - up.signoutPanel.height / 2 - up.signoutPanel.offsetY, 0));
        // signoutMesh.mesh.rotateAround(Vector3.Zero(), Vector3.Right(), up.meshRotation * Math.PI / 180);
        const signoutMeshPointerAddon = XRInputHelper.addPointerAddon(signoutMesh.mesh);
        signoutMeshPointerAddon.onPointerOut.add(() => signoutMesh.notifyChildrenOnPointerOut());
        this._userPanel = new UserPanel(panelMesh, signoutMesh, {
            loginAsync: async () => {
                if (this._appView.isApiAuth) {
                    this._userPanel.setLoginDialog(this._loginDialog);
                    this._userPanel.turnAllTogglersOff();
                    this.setLobbyActivity(false, [MeshName.lobbyUserPanel]);
                    this._appView.infoDialog.hide();
                    this._loginDialog?.show("signIn");
                }
                else {
                    await this._appView.loginAsync();
                }
            },
            logoutAsync: async () => {
                if (this._appView.isApiAuth) {
                    await this._appView.logoutApiAuthAsync();
                }
                else {
                    await this._callbacks.logoutAsync();
                }
            },
            exitXrAsync: async () => await this._appView.exitXRAsync(),
            topUpAsync: async () => await this._callbacks.topUpAsync(),
            showMessengerDialog: async () => {
                this.setLobbyActivity(false, [MeshName.lobbyUserPanel, MeshName.lobbyMessengerPanel, MeshName.lobbyMessengerEllipsisSubmenu]);
                this._appView.infoDialog.hide();
                if (await this._messengerCallbacks.hasDataAsync()) {
                    this._appView.updateHeartsAnimationPosition(this._appView.guiRootNode);
                    this._messengerPanel?.show(() => {
                        this.setLobbyActivity(true, []);
                        this._userPanel.isMessengerButtonOn = false;
                    });
                }
                else {
                    // if (this._appView.infoDialog.mode !== "messengerNoMessagesWarning") {
                    //     this._appView.infoDialog.hide();
                    // }
                    this._appView.infoDialog.show("messengerNoMessagesWarning", {
                        actionCallback: async () => {
                            this._appView.infoDialog.hide();
                            this.setLobbyActivity(true, []);
                            this._userPanel.isMessengerButtonOn = false;
                        },
                        onHideOnceCallback: () => {
                            this.setLobbyActivity(true, []);
                            this._userPanel.isMessengerButtonOn = false;
                        },
                    });
                }
            },
            hideMessengerDialog: () => {
                this._messengerChatListPanel?.hide();
                this._messengerPanel?.hide();
            },
            showEnvironmentDialog: () => {
                this.setLobbyActivity(false, [MeshName.lobbyUserPanel]);
                this._appView.infoDialog.hide();
                this._environmentDialog?.show(this._environmentData, () => {
                    this.setLobbyActivity(true, []);
                    this._userPanel.isEnvironmentButtonOn = false;
                });
            },
            hideEnvironmentDialog: () => this._environmentDialog?.hide(),
            showHelpDialog: () => { },
            hideHelpDialog: () => { },
        }, this._newFeatureBlinkHelper);
        // const up = Env.lobby.userPanel;
        // const panelMesh = MeshUtils.createPlaneMesh(MeshName.lobbyUserPanel,up.width, up.height, this._appView.scene,
        //                                        this._appView.guiRootNode, DcRenderingGroup.default);
        //
        // panelMesh.mesh.position = createVector3(new Vector3(0, 0, up.meshDistance));
        // panelMesh.mesh.rotateAround(Vector3.Zero(), Vector3.Right(), up.meshRotation * Math.PI / 180);
        // const panelMeshPointerAddon: PointerAddon = XRInputHelper.addPointerAddon(panelMesh.mesh);
        // panelMeshPointerAddon.onPointerOut.add(() => panelMesh.notifyChildrenOnPointerOut());
        //
        // const extraMesh = MeshUtils.createPlaneMesh(MeshName.lobbyUserExtraPanel, up.extraPanel.width, up.extraPanel.height, this._appView.scene,
        //     this._appView.guiRootNode, DcRenderingGroup.behindDialogs);
        // extraMesh.mesh.position = createVector3(new Vector3(-up.width/2 + up.extraPanel.width / 2, up.height /2 + up.extraPanel.height / 2 + up.signoutPanel.offsetY, up.meshDistance));
        // extraMesh.mesh.rotateAround(Vector3.Zero(), Vector3.Right(), up.meshRotation * Math.PI / 180);
        // const extraMeshPointerAddon: PointerAddon = XRInputHelper.addPointerAddon(extraMesh.mesh);
        // extraMeshPointerAddon.onPointerOut.add(() => extraMesh.notifyChildrenOnPointerOut());
        //
        // const signoutMesh = MeshUtils.createPlaneMesh(MeshName.lobbyUserSignoutPanel,up.signoutPanel.width, up.signoutPanel.height, this._appView.scene,
        //     this._appView.guiRootNode, DcRenderingGroup.default)
        // signoutMesh.mesh.position = createVector3(new Vector3(-up.width/2 + up.signoutPanel.width / 2 + up.signoutPanel.offsetX, up.height / 2 + up.signoutPanel.height / 2 + up.signoutPanel.offsetY, up.meshDistance));
        // signoutMesh.mesh.rotateAround(Vector3.Zero(), Vector3.Right(), up.meshRotation * Math.PI / 180);
        // const signoutMeshPointerAddon: PointerAddon = XRInputHelper.addPointerAddon(signoutMesh.mesh);
        // signoutMeshPointerAddon.onPointerOut.add(() => signoutMesh.notifyChildrenOnPointerOut());
        //
        // this._userPanel = new LobbyUserPanel(
        //     panelMesh,
        //     extraMesh,
        //     signoutMesh,
        //     {
        //         ...this._callbacks!,
        //         showEnvironmentDialog: () => this._environmentDialog?.show(this._environmentData),
        //         showLoginDialog: (tab?: "signUp" | "signIn") => this._loginDialog?.show(tab),
        //         // showLoginDialog: async (tab?: "signUp" | "signIn") => {tab === "signIn" ? await this._callbacks?.signInAsync("","") : await this._callbacks?.signUpAsync("", "", "")},
        //         recenter: () => {
        //             if(this._appView.isEmulation)
        //                 return;
        //             this._appView.recenter();
        //             //TODO: restore DCVR-4320
        //             // Settings.getInstance().broadcast.menuPosition = Vector3.Zero();
        //             // Settings.getInstance().broadcast.menuRotation = Quaternion.Identity();
        //         },
        //         exitXrAsync: async () => await this._appView.exitXRAsync()
        //     },
        //     this._newFeatureBlinkHelper
        // );
    }
    _createLobbyKeyboard() {
        const k = Env.broadcast.menu.keyboard;
        this._keyboard = new Keyboard3D(MeshName.lobbyKeyboard, this._appView.scene, this._appView.guiRootNode);
        this._keyboard.mesh.position = createVector3(k.position);
        this._keyboard.mesh.rotateAround(this._keyboard.mesh.position.add(Vector3.Up().scale(this._keyboard.height / 2)), Vector3.Right(), k.angleInDegrees * Math.PI / 180);
        this._hideKeyboardComponent = new HideKeyboardComponent(MeshName.lobbyHideKeyboard, this._keyboard);
    }
    _createMessengerPanel() {
        this._messengerPanel = MessengerPanel.createMessengerPanel({
            messengerPanelMeshName: MeshName.lobbyMessengerPanel,
            messengerPanelPosition: createVector3(Env.lobby.messengerPanel.position),
            ellipsisSubmenuMeshName: MeshName.lobbyMessengerEllipsisSubmenu,
            linkWarningDialogMeshName: MeshName.lobbyMessengerLinkWarningDialog,
            parentNode: this._appView.guiRootNode,
            keyboard: this._keyboard,
            hideKeyboardComponent: this._hideKeyboardComponent,
            tipsKeyboardMeshName: MeshName.lobbyMessengerTipsKeyboardPanel,
            callbacks: {
                showChatListPanel: () => {
                    this._messengerChatListPanel?.show(() => {
                        this._messengerPanel.isChatListButtonOn = false;
                    });
                    this._messengerPanel.isChatListButtonOn = true;
                },
                hideChatListPanel: () => {
                    this._messengerChatListPanel?.hide();
                    this._messengerPanel.isChatListButtonOn = false;
                },
                viewModelProfile: () => { },
                showPrivateShowOptions: () => { },
                gotoLiveRoomAsync: async (modelNickname) => {
                    await this._callbacks.openBroadcastAsync({ modelNickname: modelNickname, extraOptions: { openMessenger: true } });
                },
            },
        });
    }
    _createMessengerChatListPanel() {
        this._messengerChatListPanel = MessengerChatListPanel.createMessengerChatListPanel({
            messengerChatListMeshName: MeshName.lobbyMessengerChatListPanel,
            messengerChatListPosition: createVector3(Env.lobby.messengerChatListPanel.position),
            parentNode: this._appView.guiRootNode,
        });
    }
}
